@use '@/scss/underscore' as _;

.header {
  padding: _.unit(6) _.unit(8);
  display: flex;
  align-items: center;
  justify-content: space-between;

  > *:not(:first-child) {
    margin-left: _.unit(6);
  }

  .operations {
    display: flex;
    align-items: center;

    .moreIcon {
      color: var(--color-text-secondary);
    }

    > *:not(:first-child) {
      margin-left: _.unit(2);
    }
  }

  .metadata {
    flex: 1;

    > div {
      display: flex;
      align-items: center;

      &:not(:first-child) {
        margin-top: _.unit(2);
      }

      > *:not(:first-child) {
        margin-left: _.unit(2);
      }
    }

    .name {
      font: var(--font-title-1);
      color: var(--color-text);
    }

    .factoryName {
      background: var(--color-surface-variant);
      border-radius: 10px;
      padding: _.unit(0.5) _.unit(2);
      color: var(--color-text);
      font: var(--font-label-3);
    }

    .text {
      font: var(--font-label-2);
      color: var(--color-text-secondary);
    }

    .verticalBar {
      @include _.vertical-bar;
      height: 12px;
    }
  }
}

.codeEditor {
  margin-bottom: _.unit(6);
}

.resetIcon {
  color: var(--color-text-secondary);
}

.readme {
  padding: 0 _.unit(6);
  margin: _.unit(6);
  background-color: var(--color-layer-1);
  border-radius: 16px;
}
